import React, { useState } from "react";
import { Row, Button, Table } from "reactstrap";
import Swal from "sweetalert2";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import { DELETE_REQ_DOC } from "../../../constants/ApiPaths";
import { useSnackbar } from "notistack";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import ReqDocModal from "./ReqDocModal";

function RequiredDocument(props) {
  const defaultDocValues = {
    documentName: "",
    documentDescription: "",
    isMandatory: false,
    licenseRequiredDocId: "",
  };
  const {
    categoryId,
    tempSatatus,
    DeleteAgency,

    requiredDoc,
    sucesscallback,
  } = props;
  const [updateDocFlag, setupdateDocFlag] = useState(true);
  const [SingleDoc, setSingleDoc] = useState(defaultDocValues);
  const [reqmodal, setReqmodal] = useState(false);
  const reqtoggle = () => {
    if (DeleteAgency) return;

    setupdateDocFlag(true);
    setSingleDoc(defaultDocValues);
    setReqmodal(!reqmodal);
  };

  const { enqueueSnackbar } = useSnackbar();

  const deleteDocument = (e) => {
    if (DeleteAgency) return;

    const ID = e.currentTarget.dataset.licenserequireddocid;
    Swal.fire({
      title: "Are you want to delete this document?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteReqDoc(ID);
      }
    });
  };

  const deleteReqDoc = async (ID) => {
    if (DeleteAgency) return;

    const config = {
      method: "DELETE",
      url: DELETE_REQ_DOC,
      headers: authHeader(),
      params: {
        licenseRequiredDocId: ID,
      },
    };
    try {
      const response = await API(config);
      const { status,  message } = response.data;
      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
        sucesscallback();
      }
    } catch (error) {
      const { data } = error.response;
      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
    }
  };
  const UpdateDocument = (e) => {
    if (DeleteAgency) return;

    const DocId = e.currentTarget.dataset.licenserequireddocid;
    const SigDocValue = requiredDoc.find(
      (re) => String(re.licenseRequiredDocId) === String(DocId)
    );
    setSingleDoc(SigDocValue || defaultDocValues);
    setReqmodal(true);
    setupdateDocFlag(false);
  };

  return (
    <div>
      <Button
        className="RequiredDocumentBtn"
        disabled={DeleteAgency || tempSatatus}
        onClick={reqtoggle}
        color="primary"
      >
        <svg
          className="mr-3"
          xmlns="http://www.w3.org/2000/svg"
          width="12.401"
          height="12.402"
          viewBox="0 0 12.401 12.402"
        >
          <g
            id="Icon_feather-plus"
            data-name="Icon feather-plus"
            transform="translate(-6.6 -6.6)"
          >
            <path
              id="Path_82"
              data-name="Path 82"
              d="M18,7.5V18.1"
              transform="translate(-5.199)"
              fill="none"
              stroke="#fff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.8"
            />
            <path
              id="Path_83"
              data-name="Path 83"
              d="M7.5,18H18.1"
              transform="translate(0 -5.199)"
              fill="none"
              stroke="#fff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.8"
            />
          </g>
        </svg>
        Additional Document
      </Button>
      <Row>
        <Table className="mt-2">
          <thead>
            <tr>
              <th>Document Name</th>
              <th>Document Description </th>
              <th>Required</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {requiredDoc.map((req) => (
              <tr>
                <td>{req.documentName}</td>
                <td>
                  {req.documentDescription ? req.documentDescription : "N/A"}
                </td>
                <td>{req.isMandatory === true ? "Required" : "Not Required"}</td>
                <td>
                  {" "}
                  <div className="action-btn">
                    {" "}
                    <Button
                      disabled={DeleteAgency || tempSatatus}
                      onClick={deleteDocument}
                      data-licenserequireddocid={req.licenseRequiredDocId}
                      className="deleteBtn"
                      color="link"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10.236"
                        height="13.161"
                        viewBox="0 0 10.236 13.161"
                      >
                        <path
                          id="Icon_material-delete"
                          data-name="Icon material-delete"
                          d="M8.231,16.2a1.467,1.467,0,0,0,1.462,1.462h5.849A1.467,1.467,0,0,0,17.005,16.2V7.425H8.231ZM17.736,5.231H15.177L14.446,4.5H10.79l-.731.731H7.5V6.693H17.736Z"
                          transform="translate(-7.5 -4.5)"
                          fill="#fff"
                        />
                      </svg>
                    </Button>{" "}
                    <Button
                      disabled={DeleteAgency || tempSatatus}
                      className="editBtn"
                      color="link"
                      onClick={UpdateDocument}
                      data-licenserequireddocid={req.licenseRequiredDocId}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10.928"
                        height="10.928"
                        viewBox="0 0 10.928 10.928"
                      >
                        <path
                          id="Icon_material-mode-edit"
                          data-name="Icon material-mode-edit"
                          d="M4.5,13.148v2.276H6.776L13.49,8.711,11.214,6.434Zm10.75-6.2a.6.6,0,0,0,0-.856l-1.42-1.42a.6.6,0,0,0-.856,0L11.863,5.785,14.14,8.061,15.25,6.95Z"
                          transform="translate(-4.5 -4.496)"
                          fill="#fff"
                        />
                      </svg>
                    </Button>
                  </div>{" "}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Row>
{console.log(updateDocFlag,"updateDocFlag")}
      <ReqDocModal
        SingleDoc={SingleDoc}
        updateDocFlag={updateDocFlag}
        reqmodal={reqmodal}
        categoryId={categoryId}
        sucesscallback={sucesscallback}
        reqtoggle={reqtoggle}
      />
    </div>
  );
}

export default RequiredDocument;
